import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getMessaging, type Messaging } from "firebase/messaging";

const firebaseConfig = {
 apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// ✅ Prevent duplicate initialization
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

export const db = getFirestore(app);
// FCM only works in a secure context (HTTPS or localhost). On http://<LAN IP> getMessaging()
// throws at import time and blanks the whole app — use null there; registerFCM skips it.
export const messaging: Messaging | null = (() => {
  try {
    return window.isSecureContext ? getMessaging(app) : null;
  } catch (e) {
    console.warn("[Firebase] Messaging unavailable:", e);
    return null;
  }
})();
